import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  formField: {
    width: "100%",
    marginBottom: 24,
  },
  formField_input_wrapper: {
    position: "relative",
  },
  formField_input: {},
  formField_breakAllError: {
    wordBreak: "break-all",
  },
  formField_success: {
    '& label': {
      color: "var(--primary-main)",
    },
    '& fieldset': {
      borderWidth: 2,
      borderColor: "var(--primary-main)",
    },
  },
  mui_select_field: {},
}));
